import React, { useEffect, useState } from "react";
import { notification, Modal, Button, Card, Col, Input } from "antd";
import { useParams } from "react-router-dom";
import { TenantService } from "../../../Services";

const { TextArea } = Input;
const { confirm } = Modal;

export const SecDinination = () => {
	const { tenantName } = useParams();

	const [difinaion, seDefiniion] = useState("Hi There");
	const [originalDefinition, setOriginalDefinition] = useState("Hi There");
	const [loadingFetch, setLoadingFetch] = useState(false);
	const [loadingSave, setLoadingSave] = useState(false);

	useEffect(() => {
		const fetchTenantConfig = async () => {
			setLoadingFetch(true);
			try {
				const { data } = await TenantService.getTenantSecDifination({ tenantName });
				seDefiniion(data?.secDifination || "");
				setOriginalDefinition(data?.secDifination || "");
			} catch (error) {
				console.error("Error fetching tenant config:", error);
				notification.error({ message: "Failed to load definition" });
			} finally {
				setLoadingFetch(false);
			}
		};
		fetchTenantConfig();
	}, [tenantName]);

	const handleUpdate = () => {
		confirm({
			title: "Confirm update",
			content: "Are you sure you want to save these changes?",
			onOk: async () => {
				setLoadingSave(true);
				try {
					const { data } = await TenantService.updateTenantSecDifination({
						tenantName,
						secDifination: difinaion
					});
					seDefiniion(data?.secDifination);
					setOriginalDefinition(data?.secDifination);
					notification.success({ message: "Definition updated successfully" });
				} catch (error) {
					console.error("Error updating definition:", error);
					notification.error({ message: "Error updating definition" });
				} finally {
					setLoadingSave(false);
				}
			}
		});
	};

	return (
		<Col span={24}>
			<Card
				title="Sec Definition"
				extra={
					<Button
						type="primary"
						loading={loadingSave}
						disabled={loadingFetch || loadingSave || originalDefinition === difinaion}
						onClick={handleUpdate}
					>
						Update Definition
					</Button>
				}
			>
				<TextArea
					rows={5}
					value={difinaion}
					onChange={e => seDefiniion(e.target.value)}
					placeholder={loadingFetch ? "Loading..." : "Enter new definition"}
					disabled={loadingFetch}
				/>
			</Card>
		</Col>
	);
};

export default SecDinination;
